import React from "react";
import { Message } from "semantic-ui-react";

export default function DeprecatedBanner(params) {
    const currentVersion = "v2";

    if (currentVersion == params.version) return null;

    return (
        <Message
            error
            icon='warning circle'
            style={{
                borderRadius: 0,
                marginBottom: 0,
                marginTop: 0,
                position: "fixed",
                bottom: 0,
            }}
        >
            <Message.Content>
                <Message.Header>API Version Deprecated</Message.Header>
                This version of the MASHIE Public API is deprecated and will be
                removed in a future release. Please migrate to the v2 API.
            </Message.Content>
        </Message>
    );
}
